// index.js (simplified)
import { Child } from 'pym.js';
import { select } from 'd3-selection';
import config from './config';
import graphic from './graphic';

window.pymChild = new Child({ renderCallback: draw });

async function draw(initialWidth) {
  const container = select('#graphic');
  container.html('');

  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  const isMobile = safeWidth <= 500;
  const heightMultiplier = isMobile ? 1 : 9 / 16;
  const initialHeight = heightMultiplier * safeWidth;

  const graphicConfig = await config({ initialWidth: safeWidth, initialHeight, isMobile });
  graphic(graphicConfig, container, isMobile);
  if (window.pymChild) window.pymChild.sendHeight();
}
